export default __webpack_public_path__ + "static/media/fold.02b008a7.mp3";